// import React from "react";
// import "./VisionMission.css";

// const VisionMission = () => {
//   return (
//     <section className="vm-vision-section">
//       <div className="vm-vision-container">
        
//         <h1 className="vm-main-title">“ध्येय व उद्दिष्टे”</h1>

//         {/* VISION + MISSION ROW */}
//         <div className="vm-top-row">
//           <div className="vm-card vm-side-card">
//             <h2>आपले ध्येय (Vision)</h2>
//             <p>
//               ग्रामीण युवक आणि समाजाला दर्जेदार वाचनसाहित्य,
//               आजीवन शिक्षण आणि बौद्धिक विकासाच्या माध्यमातून
//               ज्ञान व प्रेरणेचे केंद्र बनणे.
//             </p>
//           </div>

//           <div className="vm-card vm-side-card">
//             <h2>आपले उद्दिष्ट (Mission)</h2>
//             <p>
//               ग्रामीण युवकांमध्ये वाचन संस्कृती, शिक्षण आणि सक्षमीकरण
//               वाढविण्यासाठी सुलभ व प्रभावी ग्रंथालय सेवा उपलब्ध करून देणे.
//             </p>
//           </div>
//         </div>

//         {/* OBJECTIVES LIST */}
//         <div className="vm-objectives">
//           <h2>ग्रंथालयाची उद्दिष्टे</h2>
//           <ul>
//             <li>समाजातील वाचन संस्कृती वाढविणे व जोपासणे.</li>
//             <li>साक्षरतेचे प्रमाण वाढविणे व राष्ट्रप्रेमाची भावना दृढ करणे.</li>
//             <li>दैनिक, साप्ताहिक, मासिक व इतर वाचन साहित्य उपलब्ध करून देणे.</li>
//             <li>स्पर्धा परीक्षेसाठी विद्यार्थ्यांना अभ्यासिका व मार्गदर्शन उपलब्ध करून देणे.</li>
//             <li>महागडी व दुर्मिळ पुस्तके सर्वसामान्यांसाठी उपलब्ध करणे.</li>
//             <li>हस्तकला, वक्तृत्व व निबंध स्पर्धांचे आयोजन करणे.</li>
//             <li>अंधश्रद्धा, व्यसनाधीनता इ. वाईट सवयींविरुद्ध जनजागृती करणे.</li>
//             <li>वर्धापन दिनानिमित्त व्याख्यानमालेचे आयोजन करणे.</li>
//             <li>तरुणांसाठी उद्योग व्यवसाय मार्गदर्शन शिबिरे आयोजित करणे.</li>
//             <li>बालकांसाठी संस्कार वर्ग व विविध स्पर्धांचे आयोजन करणे.</li>
//             <li>शेतकऱ्यांसाठी कृषी विषयक मार्गदर्शन व चर्चासत्रे आयोजित करणे.</li>
//             <li>ज्येष्ठ नागरिकांसाठी योगा वर्ग व वैद्यकीय तपासणी शिबिरे आयोजित करणे.</li>
//             <li>डिजिटल ग्रंथालय व ई-लायब्ररी सुविधा उपलब्ध करून देणे.</li>
//             <li>महिला सबलीकरण व लघुउद्योग मार्गदर्शन कार्यक्रम आयोजित करणे.</li>
//             <li>तरुण पिढीसाठी क्रीडा स्पर्धांचे आयोजन करणे.</li>
//           </ul>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default VisionMission;



import React, { useEffect } from "react";
import "./VisionMission.css";

const VisionMission = () => {
  useEffect(() => {
    // Staggered Animation साठी Intersection Observer
    const animatedElements = document.querySelectorAll(
      ".vm-card, .vm-objectives h2, .vm-grid-item"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vm-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    animatedElements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="vm-vision-section">
      <div className="vm-vision-container">
        <h1 className="vm-main-title">“ध्येय, उद्दिष्टे व संकल्प”</h1>

        {/* SECTION 1: VISION & MISSION */}
        <div className="vm-top-row">
          <div className="vm-card vm-side-card">
            <span className="vm-badge">Vision</span>
            <h2>आपले ध्येय</h2>
            <p>
              ग्रामीण युवक आणि समाजाला दर्जेदार वाचनसाहित्य, आजीवन शिक्षण आणि
              बौद्धिक विकासाच्या माध्यमातून ज्ञान व प्रेरणेचे केंद्र बनणे.
            </p>
          </div>

          <div className="vm-card vm-side-card">
            <span className="vm-badge">Mission</span>
            <h2>आपले उद्दिष्ट</h2>
            <p>
              ग्रामीण युवकांमध्ये वाचन संस्कृती, शिक्षण आणि सक्षमीकरण
              वाढविण्यासाठी सुलभ व प्रभावी ग्रंथालय सेवा उपलब्ध करून देणे.
            </p>
          </div>
        </div>

        {/* SECTION 2: MOBILE LIBRARY PROJECT (RRRLF) */}
        <div className="vm-project-brief vm-card">
          <h2>मोबाईल ग्रंथालय प्रकल्प (Mobile Library Project – RRRLF)</h2>
          <p>
            कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय, कोडोली (ता. पन्हाळा, जि. कोल्हापूर) 
            तर्फे ग्रामीण भागात वाचनाची सवय आणि ज्ञानाची उपलब्धता वाढवण्यासाठी 
            हा विशेष फिरता ग्रंथालय उपक्रम राबवण्यात येत आहे. हा प्रकल्प जवळपास 
            <strong> १८ ते २५ गावांपर्यंत</strong> पुस्तके घरपोच पोहोचवणार आहे.
          </p>
        </div>

        {/* SECTION 3: GRANTED OBJECTIVES */}
        <div className="vm-objectives">
          <h2>ग्रंथालयाची मुख्य उद्दिष्टे</h2>
          <div className="vm-grid">
            <div className="vm-grid-item">समाजातील वाचन संस्कृती वाढविणे व जोपासणे.</div>
            <div className="vm-grid-item">दुर्गम व डोंगराळ गावांमये थेट पु तके पोहोचवणे.</div>
            <div className="vm-grid-item">साक्षरतेचे प्रमाण वाढविणे व राष्ट्रप्रेमाची भावना दृढ करणे.</div>
            <div className="vm-grid-item">शैक्षणिक, स्पर्धा परीक्षा व बाल साहित्य मोफत उपलब्ध करणे.</div>
            <div className="vm-grid-item">दैनिक, साप्ताहिक, मासिक व इतर वाचन साहित्य उपलब्ध करून देणे.</div>
            <div className="vm-grid-item">स्पर्धा परीक्षेसाठी विद्यार्थ्यांना अभ्यासिका व मार्गदर्शन उपलब्ध करणे.</div>
            <div className="vm-grid-item">नियमित वेळापत्रकानुसार दुर्गम गावांना फिरत्या वाहनाद्वारे भेट देणे.</div>
            <div className="vm-grid-item">हस्तकला, वक्तृत्व व निबंध स्पर्धांचे आयोजन करणे.</div>
            <div className="vm-grid-item">तरुणांसाठी उद्योग व्यवसाय मार्गदर्शन शिबिरे आयोजित करणे.</div>
            <div className="vm-grid-item">महिला सबलीकरण व लघुउद्योग मार्गदर्शन कार्यक्रम आयोजित करणे.</div>
            <div className="vm-grid-item">शेतकऱ्यांसाठी कृषी विषयक मार्गदर्शन व चर्चासत्रे आयोजित करणे.</div>
            <div className="vm-grid-item">डिजिटल ग्रंथालय व ई-लायब्ररी सुविधा उपलब्ध करून देणे.</div>
          </div>
        </div>

        {/* SECTION 4: NEED & EXPECTED OUTCOMES */}
        <div className="vm-bottom-grid">
          <div className="vm-card">
            <h3>प्रकल्पाची गरज (Justification)</h3>
            <ul>
              <li>अनेक गावांमये अजूनही हक्काची ग्रंथालय सुविधा उपलब्ध नाही.</li>
              <li>ग्रामीण भागातील विद्यार्थ्यांना अभ्यास साहित्याची मोठी कमतरता भासते.</li>
              <li>डिजिटल स्क्रीनच्या अतिवापरामुळे पारंपारिक वाचन संस्कृती कमी होत आहे.</li>
              <li>मोबाईल ग्रंथालयामुळे ज्ञान थेट प्रत्येक नागरिकाच्या घराघरात पोहोचेल.</li>
            </ul>
          </div>

          <div className="vm-card">
            <h3>अपेक्षित परिणाम (Expected Outcomes)</h3>
            <ul>
              <li>ग्रामीण भागात नियमित व वेळेत पुस्तके मिळाल्याने वाचनाची सवय वाढेल.</li>
              <li>स्पर्धा परीक्षांचा अभ्यास करणाऱ्या विद्यार्थ्यांना महागडी पुस्तके मोफत मिळतील.</li>
              <li>बालकांसाठी संस्कार वर्ग व विविध उपक्रमांमुळे बौद्धिक पातळी सुधारेल.</li>
              <li>एकूणच ग्रामीण भागात व्यापक ज्ञानवृद्धी व साक्षरतेचा प्रसार होईल.</li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};

export default VisionMission;